import { useDataLoader } from "2g-hooks/fetch";

import { useCallback } from "react";

export default function useDownloadFile() {
  const loader = useDataLoader();

  return useCallback(url => {
    loader.load({
      url,
      method: "get",
      options: {
        headers: { accept: "application/octet-stream" }
      }
    });
  });
}
